"use client"
import React, { useState } from 'react';
import { storeAssigned, _scrollToUp, MiniLoader, ButtonCssClass, _handleCopyFunction } from '@/services/Methods/normalMethods';
import { DialogActions } from '@mui/material';
import _ from 'lodash';
import UseCreateAccountHook from '../../hooks/CreateAccount.hooks';
import ShoppingCartStyleCss from '@/styles/ShoppingCartStyleCss';
import ButtonComponent from '@/Inputs/ButtonComponent';
import DialogComponent from '@/Inputs/DailogComponent';
import TextFieldComponent from '@/Inputs/TextFieldComponent';
import { Email, Instagram, Share, WhatsApp } from '@mui/icons-material';
import localStorageCall from '@/services/Methods/localstorage.hook';

const Sharethispage = ({
    openMiniCart = false,
    setOpenMiniCart = (val) => alert(`you miss to pass setOpenMiniCart with value ${val}`),
    productData = [],
    section = 'Gsn',
    _minCartQuantityIncDec = (val) => alert(`you miss props _minCartQuantityIncDec with value ${val}`),
    _deleteProductFromCart = (val) => alert(`you miss props  _deleteProductFromCart with value ${val}`),
    _autoShipCheck = (val) => alert(`you miss props _autoShipCheck with value ${val}`),
    pathname,
    _changeFrequencyOfProducts, addToCartProducts, _minCartAndViewCartQuantityIncDec, userData,
    ...props
}) => {
    const [isCopied, setIscopied] = useState(false);
    const {
        openShareMyCart, setOpenShareMyCart, shareMyCartLink, setShareMyCartLink,
    } = UseCreateAccountHook();

    const REFFERAL_VALUES = localStorageCall().getItem('refferal_link');
    function callApi(link) {
        console.log("link", link);
        fetch('https://api-ssl.bitly.com/v4/shorten', {
            method: 'POST',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer d482c40cd8f6af6dcb1ba25f16356ecf8781d37e',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                group_guid: "",
                domain: "bit.ly",
                long_url: link
            })
        })
            .then(response => response.json())
            .then(json => {
                if (json.link) {
                    setShareMyCartLink(json.link);
                }
            })
            .catch(error => console.error('Error:', error));
    }
    const handleShareClick = () => {
        setOpenShareMyCart(true);

        const store = storeAssigned();

        const cleanedPathname = store
            ? pathname.replace(new RegExp(`^/${store}(/|$)`), '/')
            : pathname;

        console.log("Cleaned pathname:", cleanedPathname, userData, REFFERAL_VALUES);
        const link = `${window.location.origin}/${userData?.webAlias || REFFERAL_VALUES?.webalies}?redirectTo=${cleanedPathname}`;
        setShareMyCartLink(link);
        // callApi(link)
    };
    const store = storeAssigned();

    const cleanedPathname = store
        ? pathname.replace(new RegExp(`^/${store}(/|$)`), '')
        : pathname;

    const getProductTitle = () => {
        if (pathname.includes("khiav_mango_detox_drink_mix")) return "KHĪAV Mango Detox Drink Mix";
        if (pathname.includes("nu_spira_black_mushroom_coffee")) return "NüSpira Black Mushroom Coffee";
        if (pathname.includes("viab_liquid_multi_vitamin")) return "VĪAB Liquid Multi-Vitamin";
        if (pathname.includes("nu_spira_latte_mushroom_coffee")) return "NüSpira Latte Mushroom Coffee";


        return cleanedPathname;
    };

    return (
        <>
            <div className="sidebar-checkout-wrap">
                <ShoppingCartStyleCss>
                    <div className="mt-[8px] mb-[8px]">
                        <ButtonComponent
                            classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                            onClick={handleShareClick}
                            title="Share this Page"
                        >
                            <p className='text-[13px] font-normal'><Share /></p>
                        </ButtonComponent>
                    </div>
                </ShoppingCartStyleCss>
            </div>
            <DialogComponent opend={openShareMyCart} handleClose={() => setOpenShareMyCart(false)}
                // title={addToCartProducts?.normalProducts?.[0]?.title} 
                title={`Sharing : ${getProductTitle() || cleanedPathname} `}
                classFor="sharewebsite deleteAsking_popup">
                <div className='py-[20px]'>
                    {/* <h2 className="sharing"> Sharing : {getProductTitle() || cleanedPathname}   </h2> */}
                    {/* <p> Copy the link below to share</p> */}
                    {shareMyCartLink !== '' ?
                        <TextFieldComponent
                            name="shareMyCartLink"
                            type='text'
                            label="Copy the link below to share"
                            id="copyLink"
                            value={shareMyCartLink}
                            readOnly={true}
                            divClass={'w-full'}
                        /> : <MiniLoader />
                    }
                </div>
                <div className='socialButtonClasses'>
                    <DialogActions className='action_button xl:justify-center xl:gap-[0] xl:flex-nowrap sm:justify-start sm:flex-wrap sm:gap-[10px]' >
                        <ButtonComponent classes={"mainCopyButton site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"} onClick={() => {
                            _handleCopyFunction("copyLink");
                            setIscopied(true);
                            setTimeout(() => {
                                setIscopied(false);
                            }, 3000)
                        }}><p className='text-[13px] font-normal'>{isCopied ? 'Copied' : 'Copy Link'}</p></ButtonComponent>
                        {/* <h3 className="mt-4 text-center text-gray-600">Click the icon below to share</h3>
                        <div className='lowerButtonClasses'>

                            <button
                                className="p-3 bg-[#3c074f] rounded-md text-white"
                                onClick={() => {
                                    const emailBody = `Here is the link to the Nüspira product we discussed. It is ready to go for you! Simply review and order! You will LOVE this product!\n\n${shareMyCartLink} - ${userData?.publicProfile.fullName}`;
                                    window.location.href = `mailto:?subject=Check out this product&body=${encodeURIComponent(emailBody)}`;
                                }}
                            >
                                <Email />
                            </button>

                            <button
                                className="p-3 bg-[#4267B2] rounded-md text-white"
                                onClick={() => {
                                    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareMyCartLink)}`;
                                    window.open(facebookShareUrl, "_blank");
                                }}
                            >
                                <svg
                                    className="h-[24px] w-[24px] fill-[#fff]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                                </svg>
                            </button>

                            <button
                                className="p-3 bg-green-600 rounded-md text-white"
                                onClick={() => {
                                    const whatsappMessage = `Here is the link to the Nüspira product we discussed. It's ready to go for you! Simply review and order! You will LOVE this product!\n\n${shareMyCartLink} - ${userData?.publicProfile.fullName}`;
                                    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;
                                    window.open(whatsappUrl, "_blank");
                                }}
                            >
                                <WhatsApp />
                            </button>

                            <button
                                className="p-3 bg-[#E1306C] rounded-md text-white"
                                onClick={() => {
                                    const instagramUrl = `https://www.instagram.com/?url=${encodeURIComponent(shareMyCartLink)}`;
                                    window.open(instagramUrl, "_blank");
                                }}
                            >
                                <Instagram />
                            </button>
                        </div> */}

                    </DialogActions>
                </div>
            </DialogComponent>
        </>
    )
}
export default Sharethispage;
